import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { DefaultPopup } from '@atlas/ui';

const WithdrawalIframe = ({ data }) => {
  const [paymentUrl, setPaymentUrl] = useState(data.paymentUrl);
  const onClose = useCallback(() => {
    setPaymentUrl('');
  }, []);

  useEffect(() => {
    const messageHandler = event => {
      if (event.origin === window.location.origin) {
        if (event.data === 'closePaymentPopup') {
          onClose();
        }
      }
    };
    window.addEventListener('message', messageHandler);

    return () => {
      window.removeEventListener('message', messageHandler);
    };
  }, [onClose]);

  if (!paymentUrl) {
    return null;
  }

  return (
    <DefaultPopup headerTitle="Withdrawal" headerTitlePosition="left" onClose={onClose}>
      <div className="payment-item-container">
        <div className="payment-iframe-container">
          <iframe src={paymentUrl} />
        </div>
      </div>
    </DefaultPopup>
  );
};

WithdrawalIframe.propTypes = {
  paymentUrl: PropTypes.string.isRequired,
};

export default WithdrawalIframe;
